<template>
  <div>
    <div style="padding-top: 15px">
      <el-button type="primary" @click="showMsgCode = true">应用</el-button>
      <div class="common-search">
        <el-input style="width: 320px" v-model="searchVal" placeholder="请输入俱乐部ID或昵称搜索">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>
    <div class="common-table">
      <el-table
        v-loading="loading"
        :data="filterList"
        height="100%"
        row-key="clubId"
        @row-click="toClubAt"
      >
        <el-table-column align="center" label="编号" type="index" />
        <el-table-column align="center" label="俱乐部ID" prop="clubShowId" />
        <el-table-column align="center" label="俱乐部昵称" min-width="180" prop="clubName" />
        <el-table-column
          sortable
          align="center"
          min-width="130"
          label="俱乐部总人数"
          prop="userNum"
        />
        <el-table-column align="center" label="俱乐部状态" min-width="100">
          <template slot-scope="scope">{{ scope.row.clubStatus | clubStatusName }}</template>
        </el-table-column>
        <el-table-column sortable align="center" label="AT数量" min-width="100" prop="atNum" />
        <el-table-column align="center" label="AT开启状态数量" min-width="130" prop="atOnNum" />
        <el-table-column
          sortable
          v-if="permissions.osm_at_super_distribution"
          align="center"
          min-width="120"
          label="超级AT数量"
          prop="atOpNum"
        />
        <el-table-column
          align="center"
          label="超级AT开启状态数量"
          min-width="150"
          prop="atOpOnNum"
        />

        <el-table-column sortable align="center" label="MT数量" min-width="100" prop="mtNum" />
        <el-table-column
          sortable
          v-if="permissions.osm_at_super_distribution"
          align="center"
          label="超级MT数量"
          min-width="130"
          prop="mtOpNum"
        />
      </el-table>
    </div>

    <div v-if="showMsgCode" class="common-popup-bg">
      <div class="common-popup">
        <h3>验证</h3>
        <el-form
          size="medium"
          ref="ruleForm"
          :model="form"
          :rules="rules"
          class="common-popup-table"
          label-width="110px"
        >
          <el-form-item label="下发类型：" prop="type">
            <el-select v-model="form.type">
              <el-option
                v-for="item of typeOptions"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="手机号：" prop="mobile">
            <el-input v-model="form.mobile" placeholder="请输入">
              <el-select style="width: 100px" v-model="form.countryCode" slot="prepend">
                <el-option
                  v-for="item of mobileCountryCodeOptions"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-input>
          </el-form-item>

          <el-form-item label="谷歌验证码：" prop="code">
            <el-input v-model="form.code" placeholder="请输入"> </el-input>
          </el-form-item>
        </el-form>
        <footer>
          <el-button size="small" @click="close('ruleForm')">取消</el-button>
          <el-button size="small" @click="submitForm('ruleForm')" type="primary">确定 </el-button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { mobileCountryCodeOptions } from 'mixins';

export default {
  mixins: [mobileCountryCodeOptions],
  data() {
    return {
      searchVal: '',
      loading: false,
      showMsgCode: false,
      list: [],
      typeOptions: [
        { label: '全部', value: 0 },
        { label: 'AT用户配置', value: 1 },
        { label: 'MT用户配置', value: 2 },
      ],
      form: {
        type: 0,
        mobile: '',
        countryCode: '86',
        code: '',
      },
      rules: {
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapState('login', ['permissions']),
    filterList() {
      return this.list.filter((item) => {
        let regExp = new RegExp(this.searchVal);
        if (!this.searchVal || regExp.test(item.clubShowId) || regExp.test(item.clubName)) {
          return true;
        }
      });
    },
  },
  created() {
    this.getList();
  },
  methods: {
    ...mapActions('other', ['sendCode']),
    ...mapActions('at', ['getATClubList', 'atApply']),
    getList() {
      this.loading = true;
      this.getATClubList().then((res) => {
        this.loading = false;
        this.list = res.data || [];
      });
    },
    close(formName) {
      this.showMsgCode = false;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.atApply(this.form).then(() => {
            this.$message.success('应用成功');
            this.close(formName);
          });
        }
      });
    },
    toClubAt(row) {
      this.$router.push({
        name: 'atClubDetail',
        query: { clubId: row.clubId, clubName: row.clubName },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.common-popup-table {
  :global(.el-form-item) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  :global(.el-form-item::before) {
    content: unset !important;
  }
  :global(.el-form-item::after) {
    content: unset !important;
  }
  :global(.el-form-item__content) {
    margin-left: 0 !important;
  }
}
</style>
